import { VStack } from 'tio-ui/components/layout';
import NewTypeFourApp from 'tio-employee/components/tas/applications/new/type-four';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { TasProgramInstanceExtension as TASProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { TOC } from '@ember/component/template-only';

export interface S {
  Args: {
    model: {
      application: TasApplicationModel;
      programInstance: TASProgramInstanceModel;
    };
  };
}

const tmpl: TOC<S> = <template>
  <VStack>
    <NewTypeFourApp @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
